module.exports = __webpack_public_path__ + "img/theater_round_17.c221c825.png";